var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9412 19.268L35.227 25.086H34.951V18H31.0907V29.9985H34.3675C34.7885 29.9986 35.2007 29.8794 35.5553 29.6549C35.9099 29.4304 36.1921 29.1102 36.3685 28.732L39.0827 22.914H39.3587V29.9985H43.2174V18H39.9438C39.5224 18.0001 39.1099 18.1196 38.755 18.3443C38.4002 18.569 38.1178 18.8895 37.9412 19.268Z",
    fill: "#05754D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4637 19.5768L21.8563 25.0965H21.5803L19.9729 19.5768C19.8402 19.1223 19.5618 18.7228 19.1797 18.4384C18.7976 18.154 18.3324 18.0002 17.8542 18H14V30H17.8588V22.908H18.1347L20.3333 30H23.0958L25.3094 22.908H25.5838V30H29.4441V18H25.5823C25.1042 18.0002 24.639 18.154 24.2569 18.4384C23.8748 18.7228 23.5964 19.1223 23.4637 19.5768Z",
    fill: "#05754D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8732 23.454V30H48.7244V26.181H52.8667C53.7212 26.1806 54.5546 25.9181 55.2521 25.4297C55.9496 24.9414 56.477 24.2511 56.7616 23.454H44.8732Z",
    fill: "#05754D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8667 18H44.3213C44.5785 19.3784 45.3155 20.6242 46.4044 21.521C47.4933 22.4178 48.8653 22.9091 50.2821 22.9095H56.9169C57.0391 22.3153 57.0263 21.7016 56.8795 21.1128C56.7327 20.5241 56.4554 19.975 56.0679 19.5052C55.6803 19.0354 55.192 18.6566 54.6384 18.3963C54.0848 18.136 53.4796 18.0006 52.8667 18",
    fill: "url(#paint0_linear_8788_23734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8788_23734",
    x1: 44.3213,
    y1: 20.454,
    x2: 57.0014,
    y2: 20.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#009EDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0085C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/Mir.5683daadcbf2a8eb514c9d522b5c1429.svg";
export { ForwardRef as ReactComponent };